"use client";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./Clinicalworkflowssection.css";

export default function ClinicalWorkflowsSection() {
  const { t } = useTranslation("landingPage");
  const [active, setActive] = useState(0);

  useRevealOnScroll([active]);

  const categoriesRaw = t("workflows.categories", { returnObjects: true });
  const categories = Array.isArray(categoriesRaw) ? categoriesRaw : [];

  if (!categories.length) return null;

  const activeFeatures = Array.isArray(categories[active]?.features)
    ? categories[active].features
    : [];

  const cardsCount = activeFeatures.length;

  return (
    <section className="workflows">
      <div className="container">
        {/* Header */}
        <div className="workflows__header reveal-on-scroll reveal-up">
          <div className="workflows__header-left">
            <p className="workflows__label">{t("workflows.label")}</p>

            <h2 className="workflows__title">
              {t("workflows.title.part1")}{" "}
              <span className="workflows__title-accent">
                {t("workflows.title.accent")}
              </span>
              <br />
              {t("workflows.title.part2")}
            </h2>

            <p className="workflows__subtitle">{t("workflows.subtitle")}</p>
          </div>

          <div className="workflows__header-right reveal-on-scroll reveal-right">
            <button className="workflows__cta" type="button">
              {t("common.getStarted")}
              <span className="workflows__cta-icon">↗</span>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="workflows__body">
          {/* Sidebar nav */}
          <nav className="workflows__nav reveal-on-scroll reveal-left">
            {categories.map((cat, i) => (
              <button
                key={i}
                className={`workflows__nav-item${
                  active === i ? " workflows__nav-item--active" : ""
                }`}
                onClick={() => setActive(i)}
                type="button"
              >
                {active === i && <span className="workflows__nav-bar" />}
                {cat.title}
              </button>
            ))}
          </nav>

          {/* Cards */}
          <div
            className={`workflows__cards ${
              cardsCount === 1
                ? "workflows__cards--one"
                : cardsCount === 2
                ? "workflows__cards--two"
                : "workflows__cards--three"
            }`}
            key={active}
          >
            {activeFeatures.map((f, i) => (
              <div
                key={`${active}-${i}`}
                className="workflows__card reveal-on-scroll reveal-card"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <span className="workflows__card-tag">{f.tag}</span>

                <h3 className="workflows__card-title">{f.title}</h3>

                <p className="workflows__card-desc">{f.desc}</p>

                <div className="workflows__card-divider" />

                <p className="workflows__card-benefit">
                  <span className="workflows__card-check">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <circle cx="8" cy="8" r="8" fill="#1e1e1e" />
                      <path
                        d="M4.5 8l2.5 2.5 4.5-4.5"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  {f.benefit}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}